import React from "react";
import { Container } from "react-bootstrap";
import AppComponent from "../../../Components/AppComponent";

import UnpActions from "../../../Stores/redux/UnPersist/Actions";
import PActions from "../../../Stores/redux/Persist/Actions";
import { connect } from "react-redux";
import NavBar from "../../Components/NavBar";

const SCREEN_NAME = "REPORTS_SCREEN";

class ReportsScreen extends AppComponent {
  render() {
    return (
      <>
        <NavBar activeLink="/report" />
        <Container className="gainner">{this.props.children}</Container>
      </>
    );
  }
}

const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch) => ({
  setScreenState: (obj, persist = false, screenName = SCREEN_NAME) =>
    persist
      ? dispatch(PActions.setPScreenState(screenName, obj))
      : dispatch(UnpActions.setVScreenState(screenName, obj)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ReportsScreen);
